export const TIPOS_DENUNCIA= {
    PREVENCION_DELITO: 1,
    LEY_KARIN: 2,
    SEGUIMIENTO: 3
  };